/* eslint-disable camelcase */
import { useMemo } from 'react';
import { useCookieWatcher } from '../../../helpers/cookie';
import { AffiliateDecodedJwt, getAffiliateJwtDecoded, JWTString } from '../helpers/getAffiliateJwt';

/**
 * This hook is used to see if we have an affiliate code in the checkout and gets the information of the affiliate code.
 */
const useAffiliateCode = (): AffiliateDecodedJwt | null => {
    const [affiliateJwt] = useCookieWatcher('affiliate') as [JWTString | undefined, (value: string) => void];
    const decodedJwt = useMemo(() => getAffiliateJwtDecoded(), [affiliateJwt]);

    return decodedJwt;
};

export default useAffiliateCode;
